module.exports = __webpack_public_path__ + "img/check-mark.e374d410.svg";